import { render, staticRenderFns } from "./GraphExplorerLabelEditor.vue?vue&type=template&id=431bfd35&scoped=true&"
import script from "./GraphExplorerLabelEditor.vue?vue&type=script&setup=true&lang=js&"
export * from "./GraphExplorerLabelEditor.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431bfd35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VDialog,VTextField,VTextarea})
